<template>
  <div>
    <v-card tile elevation="0" class="item-card">
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>

      <ValidationObserver ref="observer">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6">
              <h3>問い合わせフォーム</h3>
              <div class="mt-2 mb-2">
                <div>フォームを設置する場合は、ONにしてください。</div>
                <v-switch
                  v-model="category_items.contact_form_is_show.detail"
                  :label="
                    category_items.contact_form_is_show.detail
                      ? '表示'
                      : '非表示'
                  "
                  class="pa-2 ml-auto mt-4"
                ></v-switch>
                <div>
                  フォームの内容を受け取るメールアドレスを設定してください。
                </div>
              </div>
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="問い合わせ送信先アドレス"
                :rules="`${
                  category_items.contact_form_is_show.detail ? 'required|' : ''
                }${category_items.contact_to.validation}`"
              >
                <v-text-field
                  v-model="category_items.contact_to.detail"
                  :name="category_items.contact_to.category_code"
                  :ref="category_items.contact_to.ref"
                  class="mt-4"
                  label="問い合わせ送信先アドレス"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="category_items.contact_to.placeholder"
                  hint="正しいメールアドレスを設定してください。"
                  persistent-hint
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="12">
              <div>
                フォームの画面に表示する説明文があれば、入力してください。送信ボタンの下に表示されます。
              </div>
              <v-textarea
                v-model="category_items.contact_form_comment.detail"
                :name="category_items.contact_form_comment.category_code"
                :ref="category_items.contact_form_comment.ref"
                class="mt-4"
                label="問い合わせフォームの説明文"
                :disabled="!category_items.contact_form_is_show.detail"
                :placeholder="category_items.contact_form_comment.placeholder"
                outlined
                rows="5"
                success
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
          <v-divider class="mt-4 mb-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <h3>SMTP設定</h3>
              <div class="mt-2 mb-2">
                <div>
                  メールサーバーに関する設定をしてください。どちらかのフォームの表示をONにした場合に入力。
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="送信元メールアドレス"
                :rules="category_items.from.validation"
              >
                <v-text-field
                  v-model="category_items.from.detail"
                  :name="category_items.from.category_code"
                  :ref="category_items.from.ref"
                  label="送信元メールアドレス"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="category_items.from.placeholder"
                  hint="正しいメールアドレスを設定してください。"
                  persistent-hint
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="SMTPサーバー"
                :rules="category_items.smtp_host.validation"
              >
                <v-text-field
                  v-model="category_items.smtp_host.detail"
                  :name="category_items.smtp_host.category_code"
                  :ref="category_items.smtp_host.ref"
                  label="SMTPサーバー"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="category_items.smtp_host.placeholder"
                  hint="SMTPサーバーを設定してください。"
                  persistent-hint
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="2">
              <v-select
                v-model="category_items.enc.detail"
                :name="category_items.enc.category_code"
                :ref="category_items.enc.ref"
                :items="selectItem.contactEncItem"
                label="暗号化方式"
                success
                outlined
                :disabled="!category_items.contact_form_is_show.detail"
                hint="暗号化方式を選択してください。"
                persistent-hint
              ></v-select>
            </v-col>
            <v-col cols="6" sm="2">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="ポート番号"
                :rules="category_items.smtp_port.validation"
              >
                <v-text-field
                  v-model="category_items.smtp_port.detail"
                  :name="category_items.smtp_port.category_code"
                  :ref="category_items.smtp_port.ref"
                  label="ポート番号"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="category_items.smtp_port.placeholder"
                  hint="ポート番号を設定してください。"
                  persistent-hint
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="SMTPユーザー名"
                :rules="category_items.smtp_user.validation"
              >
                <v-text-field
                  v-model="category_items.smtp_user.detail"
                  :name="category_items.smtp_user.category_code"
                  :ref="category_items.smtp_user.ref"
                  label="SMTPユーザー名"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="category_items.smtp_user.placeholder"
                  hint="SMTPユーザー名を設定してください。"
                  persistent-hint
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="SMTPパスワード"
                :rules="category_items.smtp_passwd.validation"
              >
                <v-text-field
                  v-model="category_items.smtp_passwd.detail"
                  :name="category_items.smtp_passwd.category_code"
                  :ref="category_items.smtp_passwd.ref"
                  label="SMTPパスワード"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="category_items.smtp_passwd.placeholder"
                  hint="SMTPパスワードを設定してください。"
                  persistent-hint
                  outlined
                  type="password"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-divider class="mt-4 mb-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <h3>スパム対策</h3>
              <div class="mt-2 mb-2">
                <div>
                  Cloudflareを利用したスパム対策を行う場合、以下のサイトキーとシークレットキーを設定してください。<br />
                  ※Cloudflareにてアカウントを作成し、サイトキーとシークレットキーを取得する必要があります<br />
                  <a href="https://www.cloudflare.com/ja-jp/" target="_blank"
                    >アカウント作成はこちら</a
                  >&nbsp;
                  <a
                    href="https://developers.cloudflare.com/turnstile/get-started/#get-a-sitekey-and-secret-key"
                    target="_blank"
                    >公式サイト説明</a
                  >
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="Sitekey"
                :rules="category_items.cloudflare_site_key.validation"
              >
                <v-text-field
                  v-model="category_items.cloudflare_site_key.detail"
                  :name="category_items.cloudflare_site_key.category_code"
                  :ref="category_items.cloudflare_site_key.ref"
                  label="Sitekey"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="category_items.cloudflare_site_key.placeholder"
                  hint="Sitekeyを設定してください。"
                  persistent-hint
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="SecretKey"
                :rules="category_items.cloudflare_secret_key.validation"
              >
                <v-text-field
                  v-model="category_items.cloudflare_secret_key.detail"
                  :name="category_items.cloudflare_secret_key.category_code"
                  :ref="category_items.cloudflare_secret_key.ref"
                  label="SecretKey"
                  :error-messages="errors"
                  :success="valid"
                  :disabled="!category_items.contact_form_is_show.detail"
                  :placeholder="
                    category_items.cloudflare_secret_key.placeholder
                  "
                  hint="SecretKeyを設定してください。"
                  persistent-hint
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
      </ValidationObserver>

      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import selectItem from "@/common/selectItem.js";
import imageUploaderComponent from "./imageUploader.vue";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  components: {
    imageUploaderComponent,
  },
  props: ["shop_site_id"],
  setup(props, ctx) {
    const HpListDetailRepository = repositoryFactory.get("hpListDetails");
    const refContactFormIsShow = ref(null);
    const refFrom = ref(null);
    const refSmtpHost = ref(null);
    const refEnc = ref(null);
    const refSmtpPort = ref(null);
    const refSmtpUser = ref(null);
    const refSmtpPasswd = ref(null);
    const refContactTo = ref(null);
    const refContactFormComment = ref(null);
    const refCloudflareSiteKey = ref(null);
    const refCloudflareSecretKey = ref(null);

    const data_id = 7; // お問い合わせ先 7固定
    const state = reactive({
      category_items: {
        contact_form_is_show: {
          type: "switch",
          ref: "refContactFormIsShow",
          category_num: 0, // 0固定
          category_code: "contact_form_is_show",
          name: "",
          detail: false,
          placeholder: "",
          validation: "",
        },
        from: {
          type: "text",
          ref: "refFrom",
          category_num: 0, // 0固定
          category_code: "from",
          name: "",
          detail: "",
          placeholder: "example@homepage.com",
          validation: "required|email|max:255",
        },
        smtp_host: {
          type: "text",
          ref: "refSmtpHost",
          category_num: 0, // 0固定
          category_code: "smtp_host",
          name: "",
          detail: "",
          placeholder: "homepage.com",
          validation: "required|max:255",
        },
        enc: {
          type: "text",
          ref: "refEnc",
          category_num: 0, // 0固定
          category_code: "enc",
          name: "",
          detail: "tls",
          placeholder: "",
          validation: "",
        },
        smtp_port: {
          type: "text",
          ref: "refSmtpPort",
          category_num: 0, // 0固定
          category_code: "smtp_port",
          name: "",
          detail: "587",
          placeholder: "",
          validation: "required|numeric|max:5",
        },
        smtp_user: {
          type: "text",
          ref: "refSmtpUser",
          category_num: 0, // 0固定
          category_code: "smtp_user",
          name: "",
          detail: "",
          placeholder: "",
          validation: "required|max:255",
        },
        smtp_passwd: {
          type: "text",
          ref: "refSmtpPasswd",
          category_num: 0, // 0固定
          category_code: "smtp_passwd",
          name: "",
          detail: "",
          placeholder: "",
          validation: "required|max:255",
        },
        contact_to: {
          type: "text",
          ref: "refContactTo",
          category_num: 0, // 0固定
          category_code: "contact_to",
          name: "",
          detail: "",
          placeholder: "example@homepage.com",
          validation: "email|max:255",
        },
        contact_form_comment: {
          type: "textarea",
          ref: "refContactFormComment",
          category_num: 0, // 0固定
          category_code: "contact_form_comment",
          name: "",
          detail: "",
          placeholder: "",
          validation: "",
        },
        cloudflare_site_key: {
          type: "text",
          ref: "refCloudflareSiteKey",
          category_num: 0, // 0固定
          category_code: "cloudflare_site_key",
          name: "",
          detail: "",
          placeholder: "",
        },
        cloudflare_secret_key: {
          type: "text",
          ref: "refCloudflareSecretKey",
          category_num: 0, // 0固定
          category_code: "cloudflare_secret_key",
          name: "",
          detail: "",
          placeholder: "",
        },
      },
    });

    const getListData = async () => {
      // サイト設定データ取得
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      const response = await retryRequest(
        HpListDetailRepository.list_data,
        params,
        true
      );
      if (response.data) {
        if (response.data.length === 0) {
          // データがない場合は何もしない
        } else {
          // 取得したデータをstateにセット
          for (const key of Object.keys(state.category_items)) {
            const item = state.category_items[key];
            const getItem = response.data.find(
              (i) => i.category_code === item.category_code
            );
            if (!getItem) continue; // 該当データがない場合はスキップ

            item.name = getItem.name || "";
            item.detail = getItem.detail || "";
            if (item.type === "switch") {
              item.detail = getItem.detail === "1" ? true : false;
            }
          }
        }
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    onMounted(() => {
      getListData();
    });

    watch(
      () => state.category_items.enc.detail,
      (newEnc) => {
        const encItem = selectItem.contactEncItem.find(
          (item) => item.value === newEnc
        );
        if (encItem && encItem.port) {
          state.category_items.smtp_port.detail = encItem.port;
        }
      }
    );

    const onSubmit = async () => {
      // 入力チェック エラー状態の部品が無いか調べる
      const isValid = await ctx.refs.observer.validate();

      if (state.category_items.contact_form_is_show.detail && !isValid) {
        // エラー処理
        const el = document.querySelectorAll(
          ".v-text-field.error--text, .v-textarea.error--text"
        );
        if (el.length > 0) {
          el[0].scrollIntoView();
          window.scrollBy(0, -80);
        }
        return;
      } else {
        // サイト設定保存処理
        if (!window.confirm("保存してよろしいですか？")) {
          return false;
        }

        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        for (const key of Object.keys(state.category_items)) {
          const item = state.category_items[key];
          if (item.type === "html") {
            // HTML入力処理
            item.detail = ctx.refs[item.ref][0].editorData;
          } else if (item.type === "switch") {
            item.detail = item.detail ? "1" : "0";
          } else {
            // 特に何もしない
          }
        }

        const save_list = Object.values(state.category_items).map((item) => {
          return {
            shop_site_id: props.shop_site_id,
            data_id: data_id,
            category_num: 0,
            category_code: item.category_code,
            name: item.name,
            detail: item.detail,
          };
        });
        const params = {
          shop_site_id: props.shop_site_id,
          data_id: data_id,
          save_list: save_list,
        };

        // switchの値を元に戻す
        for (const key of Object.keys(state.category_items)) {
          const item = state.category_items[key];
          if (item.type === "switch") {
            item.detail = item.detail == "1" ? true : false;
          }
        }

        await HpListDetailRepository.save_list(params)
          .then((response) => {
            if (response.data) {
              // 保存OK
              alert("問い合わせ先を保存しました。");
            }
          })
          .catch((error) => {
            throw "ERROR:HpListDetailRepository.save_list (" + error + ")";
          });

        // ローディング非表示
        store.dispatch("loadingIcon/hideIcon");

        ctx.refs.observer.reset();
      }
    };

    // 返却オブジェクト定義
    return {
      setting,
      selectItem,
      ...toRefs(state),
      onSubmit,
      refContactFormIsShow,
      refFrom,
      refSmtpHost,
      refEnc,
      refSmtpPort,
      refSmtpUser,
      refSmtpPasswd,
      refContactTo,
      refContactFormComment,
      refCloudflareSiteKey,
      refCloudflareSecretKey,
    };
  },
});
</script>
